import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"close\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m30.717 31.283-22-22 .566-.566 22 22-.566.566Z\" clip-rule=\"evenodd\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m9.283 31.283 22-22-.566-.566-22 22 .566.566Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol